import { type FunctionComponent, type PropsWithChildren, useReducer, createContext } from 'react';
import {
	mediaGalleryReducer,
	INITIAL_MEDIA_GALLERY_STATE,
	type MediaGalleryState
} from '../../reducers/media-gallery/media-gallery.reducer';

type MediaGalleryContextState = MediaGalleryState & {
	dispatch: React.Dispatch<any>;
};

const initialState: MediaGalleryContextState = {
	...INITIAL_MEDIA_GALLERY_STATE,
	dispatch: () => {}
};

export const MediaGalleryContext = createContext<MediaGalleryContextState>(initialState);

export const MediaGalleryContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
	const [state, dispatch] = useReducer(mediaGalleryReducer, { ...INITIAL_MEDIA_GALLERY_STATE });

	const value = {
		...state,
		dispatch
	};

	return <MediaGalleryContext.Provider value={value}>{children}</MediaGalleryContext.Provider>;
};
